import React, { useEffect } from 'react';
import { renderRoutes, RouteConfig } from 'react-router-config';
import styles from './index.module.scss';
import { changeLng } from '@/utils/starling';
import { useUrlQuery } from '@/utils/hooks/common';

export type MainLayoutProps = RouteConfig;

function DisplayLayout({ route }: MainLayoutProps) {
  const { language } = useUrlQuery();
  const lang: any = { CHINESE: 'cn', ENGLISH: 'en', JAPANESE: 'ja' };
  // 禁用body滚动  根据文档设置语言
  useEffect(() => {
    changeLng(lang[language] || 'cn');
    document.body.classList.add('hidden');
    return () => {
      document.body.classList.remove('hidden');
    };
  }, []);

  return (
    <div className={styles.container}>
      {renderRoutes(route.routes)}
    </div>
  );
}

export default DisplayLayout;
